import { Box, StackView } from "@planningcenter/tapestry-react"
import { Checkbox, TristateCheckbox } from "components/ui"

import { func, shape, string } from "prop-types"

const OPTIONS = [
  { attribute: "name", checked: true, disabled: true, text: "Name", wrapperClasses: "" },
  { attribute: "email_address", checked: true, disabled: true, text: "Email", wrapperClasses: "" },
  { attribute: "phone_number", text: "Phone", wrapperClasses: "" },
  { attribute: "address", text: "Address", wrapperClasses: "" }
]

const RegistrantCollectionOptions = ({ onSelect, registrantCollectionOptions }) => (
  <>
    <h4 className="label">Registration contact information to collect</h4>
    {OPTIONS.map(({ attribute, disabled, text, ...checkboxProps }) => (
      <StackView key={attribute} spacing={1} axis="horizontal" alignment="center" marginBottom={1}>
        {disabled ? (
          <Box data-tooltip={`${text} is always collected`} zIndex={0}>
            <Checkbox
              disabled={disabled}
              htmlFor={attribute}
              name={attribute}
              text={text}
              value={attribute}
              {...checkboxProps}
            />
          </Box>
        ) : (
          <TristateCheckbox
            htmlFor={attribute}
            name={attribute}
            onSelect={value =>
              onSelect({ ...registrantCollectionOptions, ...{ [attribute]: value } })
            }
            text={text}
            value={registrantCollectionOptions[attribute]}
            {...checkboxProps}
          />
        )}
      </StackView>
    ))}
  </>
)

RegistrantCollectionOptions.propTypes = {
  onSelect: func,
  registrantCollectionOptions: shape({
    name: string,
    email_address: string,
    address: string,
    phone_number: string
  })
}

export default RegistrantCollectionOptions
